import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import styled from 'styled-components';

export const HeroSectionWrapper = styled.div`
    flex: 1 1 0;
    min-width: 49%;
    display: flex;
    flex-direction: column;
    gap: 3px;

    @media (max-width: ${BreakPoints.TABLET}) {
        min-width: 0;
    }
`;
